import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { fetchMe, getCurrentUser } from './composables/useAuth'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Guard: for any route flagged `meta.requiresAuth` in routes.ts, make sure the
// session has been probed (GET /api/me) and bounce unauthenticated users to
// /login with a `next` so they return after signing in.
router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    await fetchMe()
    if (!getCurrentUser()) {
      return { path: '/login', query: { next: to.fullPath } }
    }
  }
  return true
})

export default router
